import { ocapiClient } from '../../../../api-clients/ocapi/client';
/**
 * Swaps the seats for an [[OrderShowtime]] within a [[CompletedStandardOrder]].
 */
export const swapSeatsForCompletedOrder = async (orderId, showtimeId, seats) => {
    const response = await ocapiClient.instance.v1.orders.completed.swapSeats(orderId, showtimeId, { seats });
    return response.order;
};
